<template>
  <div style="margin-top: 25px; margin-bottom: 30px;">
    <div>
        <div>
          <h1>
            Mudar senha
          </h1>
          <p>Insira as novas senhas desejadas</p>
          <form id="entrada">
            <input v-model="email" placeholder="Email" required /><br/>
            <input v-model="password" type="password" placeholder="NovaSenha" /><br/>
            <input v-model="passwordrepeat" type="password" placeholder="Confirmar Nova Senha" required /><br/>
            <button type="button" id="update_pass" @click="atualizar()">Atualizar</button>
          </form>

        <p v-if="snackbar">{{snackbarMessage}}</p>
          <p id="invalid_reset_pass" v-if="snackbarerror">{{snackbarMessageError}}</p>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    email: '',
    passwordrepeat: '',
    password: '',
    error_message: false,
    snackbar: false,
    snackbarMessage: "Atualizado",
    snackbarerror : false,
    snackbarMessageError: "Não foi possível atualizar a senha",
  }),
  methods: {
    atualizar(){
      let token = this.$route.params.token;
      if(this.email && this.password && this.passwordrepeat && token){
        if(this.password == this.passwordrepeat){
          this.$http.post('/projects/reset-password', {
            email: this.email, token: token, password: this.password
          }).then(res => {
            console.log("DEU CERTO");
            this.snackbar = true;
            this.snackbarMessage = res.data.message;
          }).catch(err => {
            console.log("EERRRR");
            console.log(err);
            this.snackbarerror=true;
            
            if(err.error)
                this.snackbarMessageError = err.error;
            else{
                this.snackbarMessageError = "Não foi possível modificar.";
            }
          })
        }
      } else{
          this.snackbarerror = true;
          this.snackbarMessageError = "Insira todos os dados."
      }
    },
    verifyKey(){
      let {token} = this.$route.params;
      this.$http.get(`/validar-token/${token}`).then(() => {return true}).catch(() => {
        
        return false
        });
    }
  },
};
</script>

<style>
#entrada input{
    border: 1px solid grey;
    padding: 10px;
    border-radius: 3px;
    margin: 10px;
    width: 35%;
}

#update_pass{
    background-color: #8d816b;
    padding: 10px;
    color: #ffffff;
    font-weight: 700;
    border-radius: 3px;
    width: 35%;
}

#invalid_reset_pass{
    font-size: 14px;
    font-weight: 700;
    color: #D50000;
    margin: 20px 0;
}
</style>